export default __webpack_public_path__ + "static/media/time_icon.9f5603b1.svg";